import React from 'react';
import I18n from '@/modules/i18n';
import { dateTimeToUserTimeZone } from '@/utils/functions';
import Icon from '@/components/ui/Icon';

interface TitleRowProps {
  assignmentName?: string;
  dueDatetime?: string;
  lessonLocation?: string;
}

const TitleRow = ({ assignmentName, dueDatetime, lessonLocation }: TitleRowProps) => {
  // `datetimeStr` is of the form "Unit x - Lesson y - ..."
  const formattedLessonString = (datetimeStr) => {
    // Regex to remove the initial "Unit x - " (case-insensitive)
    const unitRegex = /^Unit\s*\d+\s*-\s*/i;
    const withoutUnit = datetimeStr.replace(unitRegex, '');

    // Regex to extract "Lesson x"
    const lessonRegex = /^(Lesson\s*\d+)/i;
    const lessonMatch = withoutUnit.match(lessonRegex);

    if (!lessonMatch) return <span>{withoutUnit}</span>;

    const lessonText = lessonMatch[1];
    // Compute remainder (strip "Lesson x" and a dash and any spaces)
    const rest = withoutUnit.slice(lessonMatch[0].length).replace(/^\s*-\s*/, '');

    return (
      <>
        <strong>{lessonText}</strong>
        {rest ? ` - ${rest}` : ''}
      </>
    );
  };

  return (
    <div className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-w-full tw-leading-normal">
      <div className="tw-flex tw-flex-row tw-items-center">
        {assignmentName && (
          <div className={`tw-max-w-[344px] tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap
                           tw-items-center
                           tw-font-bold tw-text-lg
                           tw-border-r tw-border-solid tw-border-med-grey tw-pr-2 tw-mr-3`}
          >
            {assignmentName}
          </div>
        )}
        <div className="tw-max-w-[300px] tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap">
          {formattedLessonString(lessonLocation)}
        </div>
      </div>

      <div className="tw-flex tw-flex-row tw-items-center">
        <Icon
          className="tw-text-med-grey"
          icon="Time"
        />
        <span className="tw-font-bold tw-ml-1.5 tw-mr-1">{I18n.t('due')}:</span>
        <span className="tw-font-normal !tw-m-0">
          {dateTimeToUserTimeZone(dueDatetime, 'MM/DD/YYYY hh:mm A z')}
        </span>
      </div>
    </div>
  );
};

export default TitleRow;
